<template>
  <button class="auth-button--login" @click="handleLogin">Log In</button>
</template>

<script setup>
import { useAuth } from "@/auth/auth";
import "./button-styles.css"
const { login } = useAuth();

const handleLogin = () => {
  login({ redirectPath: "/chat" });
};
</script>
